import CollectionCardRow from "./collection-card-row";

export default CollectionCardRow;